import React from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { setFileContentTwo, setAdminProductUploadStatus } from '../../actions/admin';
import close from '../../images/close.png';

const AdminActionModal  = () => {
  const dispatch = useDispatch();
  const { productActionSelection, productActionSelectionList, adminProductUploadState,
          fileContentTwo, adminProductUploadResponse } = useSelector(state => state.admin);
  const closeAdminProductUploadState = () => dispatch(setAdminProductUploadStatus(undefined));
  // console.log(filterByProductName);

const productActionSubmit = (e) => {
  e.preventDefault();
  //const movieName = e.target.elements.name.value.trim()
  //const file = fileContent;
  const file2 = fileContentTwo;
  // dispatch(addSeries(movieName, cast, catID, description, file, file2));
};

//kkkf

// const handleChange = event => {
//   const categoryValue = event.target.value;
//   const getCategoryId = categories.filter((data) => {
//     return data.name === categoryValue;
//   });
//   dispatch(setCategoryId(getCategoryId[0]._id));
//   return getCategoryId[0]._id;
  
// };

// const fileSelectedHandler = (e) => {
//   dispatch(setFileContent(e.target.files[0]))
// };

const fileSelectedHandlerTwo = (e) => {
  dispatch(setFileContentTwo(e.target.files[0]))
};


  return (
    <div className='join-group'>
      <Modal isOpen={adminProductUploadState}
        onRequestClose={closeAdminProductUploadState}
        ariaHideApp={false}
        contentLabel="lifecarefront.com"
        closeTimeoutMS={400}
        className='join-group-modal'>
          <div className='join-group-inner2'>
            <form onSubmit={productActionSubmit} className='join-group-form'>
              <table className='join-group-form-table'>
                <tbody>
                  <tr>
                    <td className='jpft-td'>{productActionSelection.toUpperCase()} CSV</td>
                    <td className='jpft-td2'><img onClick={() => {
                        dispatch(setAdminProductUploadStatus(false));
                      }} className='add-genre-close' src={close} alt='Life Care Front' title='Life Care Front'/></td>
                  </tr>
                </tbody>
              </table>

              <p className='cat-lab'>
                {productActionSelection.toUpperCase()} File*
                </p>
                {/* <input className='join-group-input'  
                  onChange={fileSelectedHandlerTwo} name='file' type='file' 
                  placeholder='Image URL' accept="image/*"  /> */}
                <input className='join-group-input'  
                  onChange={fileSelectedHandlerTwo} name='file' type='file' 
                  placeholder='Image URL' />

              <button className='join-group-submit'> 
                {adminProductUploadResponse === 'uploading...' ? 'uploading...' : 'Upload Product'}
              </button>
              <p>{adminProductUploadResponse}</p>
            </form>
          </div>
      </Modal>
    </div>
  );
};

export default AdminActionModal;
